import { GitHub, LinkedIn } from "@mui/icons-material";
import { Link } from "react-router-dom";

const Test2 = () => {
  return (
    <>
      {/* <div className="wrp2">
        <div className="name">
          <h2>M</h2>
          <h2>A</h2>
          <h2>Y</h2>
          <h2>A 's</h2>
        </div>
        <div className="portfolio">
          <h2>P</h2>
          <h2>O</h2>
          <h2>R</h2>
          <h2>T</h2>
          <h2>F</h2>
          <h2>O</h2>
          <h2>L</h2>
          <h2>I</h2>
          <h2>O</h2>
        </div>
      </div> */}

      {/* <div className="text">
        <p>
          Hi, I'm Maya ! An Aspiring front-end developer .I am passionate about
          creating visually engaging and user-friendly websites. Enthusiastic
          about learning the latest web technologies and design trends to craft
          intuitive and responsive interfaces. Seeking opportunities to
          kickstart a career in front-end development and collaborate on
          exciting projects. My dedication to self-improvement and creative
          problem-solving drives me to excel in this dynamic field. This
          portfolio showcases my journey, experiments, and projects, reflecting
          my eagerness to grow as a developer.
        </p>
      </div> */}

      <div className="cont-card-wrp">
        <h2 className="hello-sm">Hello World</h2>
        <div className="card1">
          <h2>Hello</h2>
          <h2>World</h2>
          <p>
            Hi, I'm Maya ! An Aspiring Front End developer with solid
            understanding of back-end development.{" "}
            <b>
              Main skills: Javascript TypeScript | React JS | Node JS | Next JS|
              Angular.{" "}
            </b>{" "}
            I am passionate about creating visually engaging and user-friendly
            websites.I have about a year of experience. Seeking opportunities to
            kickstart a career in Web development and collaborate on exciting
            projects. This portfolio showcases my journey, experiments, and
            projects, reflecting my eagerness to grow as a developer.
          </p>

          <div className="figure">
            {/* <img
              src="https://stickerswiki.ams3.cdn.digitaloceanspaces.com/stickerscloud_21541bc1edcedfb4311c664ac_879_by_StickersCloud_Bot/7920977.512.webp"
              // alt="emoji"
            /> */}
          </div>
        </div>
      </div>

      <div sx={{ padding: "30px" }} className="buttons">
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={"https://www.linkedin.com/in/maia-kiknavelidze-459864253/"}
        >
          {" "}
          <button>
            <LinkedIn sx={{ fontSize: "45px" }} />
          </button>
        </Link>
        <Link
          target="_blank"
          rel="noopener noreferrer"
          to={"https://github.com/slunecnicee"}
        >
          {" "}
          <button>
            <GitHub sx={{ fontSize: "45px" }} />
          </button>
        </Link>
      </div>
    </>
  );
};

export default Test2;
